export const title = 'Usuários ativos';

Quantidade de usuários únicos que abriram o app pelo menos uma vez.